import {
  Checkbox,
  Col,
  DatePicker,
  Form,
  Input,
  InputNumber,
  Radio,
  Row,
  Select,
  Space,
  Spin,
} from "antd";
import moment from "moment";
import { Button as PrimeBtn } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { Toast } from "primereact/toast";
import React, { useEffect, useRef, useState } from "react";
import { getAllAgencies, getAllAgenciesFormats } from "../../../apis/AgencyApis";
import { updateProject } from "../../../apis/ProjectApis";
import informationImage from "../../../resources/information.png";
import { UPDATE_ASSIGNER_REWARD, conditionForUpdateAdjustment, conditionForUpdatePriority, hasPermission } from "../../../utils/constants";
import AddAgencyDialog from "../../agency/dialog/addagencydialog";
import { getCustomValueByKeyLike } from "../../../apis/AdminApis";
import { buildCustomerData, buildSummary, showProjectAgencyFormat } from "../../../utils/projectUtils";

const UpdateProjectForm = (props) => {
  const [selectedAgency, setSelectedAgency] = useState(null);
  const [agencies, setAgencies] = useState([]);
  const [agency, setAgency] = useState(null);
  const [priority, setPriority] = useState(null); 
  const [priorityCustomer, setPriorityCustomer] = useState(null); 

  const [product, setProduct] = useState(false);
  const [visibleAgencyDialog, setVisibleAgencyDialog] = useState(false);
  const [isfurnished, setIsFurnished] = useState(false);
  const [informationDialog, setInformationDialog] = useState(false);
  const [apiLoading, setApiLoading] = useState(false);
  const [form] = Form.useForm();
  const toast = useRef(null);
  const { Option } = Select;

  const [newProjectConfig, setNewProjectConfig] = useState([]);
  const [customerDataFormValues, setCustomerDataFormValues] = useState({});
  const [customerDataNotes, setCustomerDataNotes] = useState({}); 
  const [customFormat, setCustomFormat] = useState("");
  const [agencyFormats, setAgencyFormats] = useState([]);
  const [initialInvoiceInfo, setInitialInvoiceInfo] = useState({
    adjustmentContractorRate: null,
    adjustmentQCerRate: null,
    adjustmentFinalCheckerRate: null
  });
  const [initialAdjustmentRate, setInitialAdjustmentRate] = useState(null);

  const getAllFormat = () => {
    setApiLoading(true);
    getAllAgenciesFormats()
      .then((res) => {
        if (res.status === 200) {
          let sortedFormats = res.data.sort((a, b) => {
            const aHasStandard = /standaard|standard/i.test(a.name) ? 1 : 0;
            const bHasStandard = /standaard|standard/i.test(b.name) ? 1 : 0;
            if (aHasStandard !== bHasStandard) {
              return bHasStandard - aHasStandard; // those with standard first
            }
            return a.name.localeCompare(b.name);
          });
        
          setAgencyFormats(sortedFormats);
          setApiLoading(false);
        } else {
          toast.current.show({
            severity: "error",
            summary: "Status",
            detail: res.response.data,
            life: 3000,
          });
          setApiLoading(false);
        }
      })
      .catch((e) => {
        setApiLoading(false);
      });
  };

  const loadAllAgencies = () => {
    setApiLoading(true);
    getAllAgencies()
      .then((res) => {
        if (res.status === 200) {
          setAgencies(res.data);
          setApiLoading(false);
        } else {
          toast.current.show({
            severity: "error",
            summary: "Status",
            detail: res.response.data,
            life: 3000,
          });
          setApiLoading(false);
        }
      })
      .catch((e) => {
        toast.current.show({
          severity: "error",
          summary: "Status",
          detail: e,
          life: 3000,
        });
        setApiLoading(false);
      });
  };

  const fetchNewProjectConfig = () => {
    setApiLoading(true);
    getCustomValueByKeyLike("NEW_PROJECT_CONFIG_")
      .then((response) => {
        if (response.status === 200) {
          let config = (response.data).map((r) => (
            {
              values: r.key.split("_TYPE_CHECKBOX_")[1].split("_"),
              label: r.value,
              companyId: props.project?.company?.id,
              key : r.key
            }
          ))

          let customerData = props.project?.customerData ? JSON.parse(props.project?.customerData) : [];
          const values = {};
          const customerDataNotes = {};

          for(let item of config){
            let value = customerData.find(i => i.key == item.key)?.value;
            values[item.label] = value;

            let note = customerData.find(i => i.key == item.key)?.note;
            customerDataNotes[item.label] = note;
          }

          setCustomerDataFormValues(values);
          setCustomerDataNotes(customerDataNotes);
  
          setNewProjectConfig(config);
          setApiLoading(false);
        } else {
          toast.current.show({
            severity: "error",
            summary: "Status",
            detail: response.response.data,
            life: 3000,
          });
          setApiLoading(false);
        }
      })
      .catch((e) => {
        toast.current.show({
          severity: "error",
          summary: "Status",
          detail: e,
          life: 3000,
        });
        setApiLoading(false);
      });
  };

  useEffect(() => {
    loadAllAgencies();
    fetchNewProjectConfig();
    getAllFormat();
    if (props?.project) {
      setProduct(props.project.product);
      setIsFurnished(props.project.furnishedType);
      form.setFieldsValue({ agency: props.project.agency.id });
      form.setFieldsValue({ measurementType: props.project.measurementType });
      form.setFieldsValue({ houseType: props.project.houseType });
      form.setFieldsValue({ product: props.project.product });
      form.setFieldsValue({ city: props.project.city });
      form.setFieldsValue({ street: props.project.street });
      form.setFieldsValue({ number: props.project.number });
      form.setFieldsValue({ postalCode: props.project.postalCode });
      form.setFieldsValue({ ndd: props.project.ndd });
      form.setFieldsValue({ furnishedType: props.project.furnishedType });
      form.setFieldsValue({ projectOption: props.project.projectOption });
      form.setFieldsValue({
        measurementDate: moment(props.project.measurementDate, "YYYY-MM-DD"),
      });
      if(props.project.reportMeasurementDate){
        form.setFieldsValue({
          reportMeasurementDate: moment(props.project.reportMeasurementDate, "YYYY-MM-DD"),
        });
      }
      form.setFieldsValue({
        adjustmentDate: props.project.adjustmentDate
          ? moment(props.project.adjustmentDate, "YYYY-MM-DD")
          : "",
      });
      form.setFieldsValue({ adjustmentContractorRate: props.project?.invoiceInfo?.adjustmentContractorRate });
      form.setFieldsValue({ adjustmentQCerRate: props.project?.invoiceInfo?.adjustmentQCerRate });
      form.setFieldsValue({ adjustmentFinalCheckerRate: props.project?.invoiceInfo?.adjustmentFinalCheckerRate });
      // Store initial values for change detection
      setInitialInvoiceInfo({
        adjustmentContractorRate: props.project?.invoiceInfo?.adjustmentContractorRate,
        adjustmentQCerRate: props.project?.invoiceInfo?.adjustmentQCerRate,
        adjustmentFinalCheckerRate: props.project?.invoiceInfo?.adjustmentFinalCheckerRate
      });
      form.setFieldsValue({ adjustmentRate: props.project.adjustmentRate });
      setInitialAdjustmentRate(props.project.adjustmentRate);

      form.setFieldsValue({ adjustment: props.project.adjustment });
      form.setFieldsValue({ adjustmentMadeBy: props.project.adjustmentMadeBy });
      form.setFieldsValue({ report: props.project.report });
      form.setFieldsValue({ projectMessage: props.project.projectMessage });
      form.setFieldsValue({ customerMessage: props.project.customerMessage });
      form.setFieldsValue({ assignerReward: props.project.assignerReward });
      form.setFieldsValue({ customFormat: props.project.customFormat ? props.project.customFormat : props.project.agency.format });
      form.setFieldsValue({ customAgencyFormat: props.project.customAgencyFormat ? props.project.customAgencyFormat.id : props.project.agency.optionalAgencyFormat?.id });
      setPriority(props.project.priority);
      setPriorityCustomer(props.project.priorityCustomer);
      setCustomFormat(props.project.customFormat);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.project]);

  const agencyOptions = (agencies || []).map((r) => (
    <Option key={r.id} value={r.id}>
      {r.name}
    </Option>
  ));

  const handleSubmit = () => {
    form.validateFields().then((values) => {
      setApiLoading(true);
      let summary = buildSummary(newProjectConfig, props.project?.company?.id, customerDataFormValues, customerDataNotes);
      const { customAgencyFormat, customFormat, agency, measurementDate, reportMeasurementDate, projectMessage, customerMessage, adjustmentRate, ...otherValues } = values;
      
      // If custom format is selected and it's different from agency's standard format, then send custom agency format, otherwise send null to avoid confusion at backend
      let customAgencyFormatObj = showProjectAgencyFormat(props.project, agency, customFormat) && customAgencyFormat != null ? { id: customAgencyFormat } : null;
      
      // Track which fields were modified
      const modifiedFields = [];
      
      // Build invoiceInfo with only changed fields (null for unchanged fields)
      const invoiceInfo = {};
      let hasChangedInvoiceInfo = false;
      
      if (values.adjustmentContractorRate !== initialInvoiceInfo.adjustmentContractorRate) {
        invoiceInfo.adjustmentContractorRate = values.adjustmentContractorRate;
        modifiedFields.push('adjustmentContractorRate');
        hasChangedInvoiceInfo = true;
      }
      if (values.adjustmentQCerRate !== initialInvoiceInfo.adjustmentQCerRate) {
        invoiceInfo.adjustmentQCerRate = values.adjustmentQCerRate;
        modifiedFields.push('adjustmentQCerRate');
        hasChangedInvoiceInfo = true;
      }
      if (values.adjustmentFinalCheckerRate !== initialInvoiceInfo.adjustmentFinalCheckerRate) {
        invoiceInfo.adjustmentFinalCheckerRate = values.adjustmentFinalCheckerRate;
        modifiedFields.push('adjustmentFinalCheckerRate');
        hasChangedInvoiceInfo = true;
      }
      
      // Only include adjustmentRate if it has changed
      const adjustmentRateValue = adjustmentRate !== initialAdjustmentRate ? adjustmentRate : undefined;
      
      const projectValues = {
        id: props.project && props.project.id ? props.project.id : null,
        measurementDate: moment(measurementDate).format("YYYY-MM-DD"),
        reportMeasurementDate: moment(reportMeasurementDate).format("YYYY-MM-DD"),
        agency: { id: agency },
        report: values.report != null ? values.report : props.project.report,
        invoiceInfo: hasChangedInvoiceInfo ? invoiceInfo : null,
        ...(adjustmentRateValue !== undefined && { adjustmentRate: adjustmentRateValue, modifiedFields: [...modifiedFields, 'adjustmentRate'] }),
        ...(adjustmentRateValue === undefined && modifiedFields.length > 0 && { modifiedFields }),
        priority: priority,
        priorityCustomer: priorityCustomer,
        projectMessage: projectMessage,
        customerMessage: customerMessage,
        customerData: buildCustomerData(newProjectConfig, props.project?.company?.id, customerDataFormValues, customerDataNotes),
        projectComment: [{comment: summary}],
        customFormat: customFormat,
        customAgencyFormat: customAgencyFormatObj,
        ...otherValues,
      };

      updateProject(projectValues)
        .then((res) => {
          if (res.status === 200) {
            toast.current.show({
              severity: "success",
              summary: "Status",
              detail: "Project Edit Successfully",
              life: 3000,
            });
            setApiLoading(false);
            props.setVisible(false);
          } else {
            toast.current.show({
              severity: "error",
              summary: "Status",
              detail: res.response.data,
              life: 3000,
            });
            setApiLoading(false);
          }
        })
        .catch((e) => {
          toast.current.show({
            severity: "error",
            summary: "Status",
            detail: e,
            life: 3000,
          });
          setApiLoading(false);
        });
    });
  };

  const disabledDate = (current) => {
    // Can not select days before today and today
    // return current && current < moment().endOf("day");
    // can not select saturday and sunday
    return moment(current).day() === 0 || moment(current).day() === 6;
  };

  const changeVisibleAgencyDialog = (bool) => {
    setSelectedAgency(false);
    setApiLoading(false);
    if (bool === false) {
      loadAllAgencies();
    }
    setVisibleAgencyDialog(bool);
  };

  const handleCheckboxChange = (e) => {
    setPriority(e.target.checked);
  };

  const handleCheckboxCustomerChange = (e) => {
    setPriorityCustomer(e.target.checked);
  };

  const handleRadioChange = (label, value) => {
    setCustomerDataFormValues(prev => ({ ...prev, [label]: value }));
  };

  const handleNoteChange = (label, value) => {
    setCustomerDataNotes(prev => ({ ...prev, [label]: value }));
  };

  return (
    <React.Fragment>
      <Toast ref={toast} />
      <Spin spinning={apiLoading}>
        <div
          style={{ display: "flex", marginTop: "30px", marginBottom: "20px" }}
        >
          <Form
            form={form}
            size="middle"
            className="custom-form-design"
            onFinish={handleSubmit}
            wrapperCol={{ span: 10 }}
            labelCol={{ span: 10 }}
          >
            <Row>
              <Col span={12}>
                <Form.Item
                  name="product"
                  label="Product"
                  required
                  rules={[
                    {
                      required: true,
                      message: "Product is required.",
                    },
                  ]}
                >
                  <Select
                    onChange={(e) => {
                      form.setFieldsValue({
                        houseType: null,
                        furnishedType: null,
                      });
                      setProduct(e);
                    }}
                    style={{ width: 150 }}
                    placeholder="Select"
                    dropdownStyle={{ zIndex: "9999" }}
                  >
                    <Option value="BOG">BOG</Option>
                    <Option value="House">House</Option>
                  </Select>
                </Form.Item>
                <Form.Item
                  name="report"
                  label="Report"
                  required
                  rules={[
                    {
                      required: true,
                      message: "Please Enter Report",
                    },
                  ]}
                >
                  <Select
                    style={{ width: 150 }}
                    placeholder="Select"
                    dropdownStyle={{ zIndex: "9999" }}
                  >
                    <Option value="Yes">Yes</Option>
                    <Option value="No">No</Option>
                  </Select>
                </Form.Item>
                <Form.Item
                  name="city"
                  label="City"
                  required
                  rules={[
                    {
                      required: true,
                      message: "Please Enter City",
                    },
                  ]}
                >
                  <Input />
                </Form.Item>
                <Form.Item
                  name="street"
                  label="Street"
                  required
                  rules={[
                    {
                      required: true,
                      message: "Please Enter Street",
                    },
                  ]}
                >
                  <Input />
                </Form.Item>
                <Form.Item
                  name="number"
                  label="Number"
                  required
                  rules={[
                    {
                      required: true,
                      message: "Please Enter Number",
                    },
                  ]}
                >
                  <Input />
                </Form.Item>
                <Form.Item
                  name="postalCode"
                  label="Post Code"
                  required
                  rules={[
                    {
                      required: true,
                      message: "Please Enter Post Code",
                    },
                  ]}
                >
                  <Input />
                </Form.Item>
                <Row>
                  <Col span={20}>
                    <Form.Item
                      name="agency"
                      label="Agency"
                      wrapperCol={{ span: 11 }}
                      labelCol={{ span: 12 }}
                      rules={[
                        {
                          required: true,
                          message: "Please select agency from list",
                        },
                      ]}
                    >
                      <Select
                        showSearch
                        dropdownStyle={{ zIndex: "9999" }}
                        filterOption={(input, option) =>
                          option.children
                            .toLowerCase()
                            .indexOf(input.toLowerCase()) >= 0
                        }
                        onChange={(e) => {
                          let findAgency = agencies.find(t => t.id == e);
                          setAgency(findAgency);

                          // reset custom format and custom agency format when agency changes to avoid confusion, user can select again if needed
                          setCustomFormat(findAgency?.format);
                          form.setFieldsValue({ customFormat: findAgency?.format});
                          form.setFieldsValue({ customAgencyFormat: null });
                        }}
                      >
                        {agencyOptions}
                      </Select>
                    </Form.Item>
                  </Col>
                  <Col span={1}>
                    <PrimeBtn
                      className="p-button-rounded my-auto ml-1"
                      type="button"
                      icon="pi pi-plus"
                      style={{
                        backgroundColor: "#037eea",
                        borderColor: "#037eea",
                      }}
                      onClick={(e) => {
                        e.stopPropagation();
                        setApiLoading(true);
                        setVisibleAgencyDialog(true);
                      }}
                    />   
                  </Col>
                </Row>
                <Row>
                  <Col span={20}>
                    <Form.Item name="customFormat"
                      wrapperCol={{ span: 11 }}
                      labelCol={{ span: 12 }} label="Format">
                      <Radio.Group
                        onChange={(e) => {
                          setCustomFormat(e.target.value);
                          form.setFieldsValue({ customAgencyFormat: agency != null ? agency.optionalAgencyFormat?.id : props.project.agency.optionalAgencyFormat?.id });
                        }}
                        style={{ display: "flex", gap: "10px" }}
                      >
                        <Radio value="floorplanner">Floorplanner</Radio>
                        <Radio value="Autocad">Autocad</Radio>
                      </Radio.Group>
                    </Form.Item>
                  </Col>
                  <Col span={4} style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <label>
                      Standard Type: {agency != null ? agency.format : props.project.agency.format}
                    </label>
                  </Col>
                </Row>

                {showProjectAgencyFormat(props.project, agency, customFormat) && 
                <Row> 
                  <Col span={20}>
                    <Form.Item name="customAgencyFormat"
                      wrapperCol={{ span: 11 }}
                      labelCol={{ span: 12 }} label="Agency Format">
                      <Select
                        placeholder="Select"
                        dropdownStyle={{ zIndex: "9999" }}
                      >
                        {agencyFormats?.filter(item => item?.company?.id == props.project.company.id).map((item) => {
                          return (
                            <Option key={item.id} value={item.id}>
                              {item.name}
                            </Option>
                          );
                        })}
                      </Select>
                    </Form.Item>
                  </Col>
                </Row> }
                {conditionForUpdateAdjustment(props.permissions) ?
                  <>
                    <Form.Item name="adjustmentRate" label="Adjusted Price">
                      <InputNumber />
                    </Form.Item>
                    <Form.Item name="adjustmentContractorRate" label="Adjusted Contractor Price">
                      <InputNumber />
                    </Form.Item>
                    <Form.Item name="adjustmentQCerRate" label="Adjusted Quality Checker Price">
                      <InputNumber />
                    </Form.Item>
                    <Form.Item name="adjustmentFinalCheckerRate" label="Adjusted Final Checker Price">
                      <InputNumber />
                    </Form.Item>
                    <Form.Item name="adjustment" label="Adjustment">
                      <Radio.Group defaultValue={"None"}>
                        <Radio value="Small">Small</Radio>
                        <Radio value="Big">Big</Radio>
                        <Radio value="Remake">Remake</Radio>
                        <Radio value="Without Cost">Without Cost</Radio>
                      </Radio.Group>
                    </Form.Item>
                  </> : ""}
                {hasPermission(props.permissions, UPDATE_ASSIGNER_REWARD) && props.project?.assigner != null ?
                  <>
                    <Form.Item name="assignerReward" label="Final Checker Reward">
                      <InputNumber />
                    </Form.Item>
                  </> : props.project?.assigner?.id === props?.currentUser?.id && <>
                    <Form.Item name="assignerReward" label="Final Checker Reward">
                      <InputNumber readOnly="true"/>
                    </Form.Item>
                  </>}
                  
              </Col>
              <Col span={12}>
                <Form.Item label="NDD">
                  <Space>
                    <Form.Item
                      name="ndd"
                      required
                      rules={[
                        {
                          required: true,
                          message: "NDD is required.",
                        },
                      ]}
                    >
                      <Select
                        style={{ width: 150 }}
                        placeholder="Select"
                        dropdownStyle={{ zIndex: "9999" }}
                      >
                        <Option value="Yes">Yes</Option>
                        <Option value="No">No</Option>
                      </Select>
                    </Form.Item>
                    <div
                      value="Yes"
                      style={{
                        marginLeft: "10px",
                        fontSize: "large",
                        color: "blue",
                      }}
                      onClick={() => setInformationDialog(true)}
                      class="pi pi-info-circle"
                    />
                  </Space>
                </Form.Item>
                <Form.Item
                  name="furnishedType"
                  label="Is Furnished"
                  required
                  rules={[
                    {
                      required: true,
                      message: "Please specify isFurnished?",
                    },
                  ]}
                >
                  <Select
                    style={{ width: 150 }}
                    dropdownStyle={{ zIndex: "9999" }}
                    onChange={(e) => {
                      form.setFieldsValue({ houseType: null });
                      setIsFurnished(e);
                    }}
                    placeholder="Select"
                  >
                    <Option
                      disabled={product === "BOG" ? true : false}
                      value="Yes"
                    >
                      Yes
                    </Option>
                    <Option value="No">No</Option>
                  </Select>
                </Form.Item>
                <Form.Item
                  name="houseType"
                  label="House Type"
                  required
                  rules={[
                    {
                      required: true,
                      message: "Please Select House Type",
                    },
                  ]}
                >
                  <Select
                    style={{ width: 150 }}
                    dropdownStyle={{ zIndex: "9999" }}
                    placeholder="Select"
                  >
                    <Option value="A">A</Option>
                    <Option value="B">B</Option>
                    <Option value="C">C</Option>
                    <Option value="D">D</Option>
                    <Option value="E">E</Option>
                  </Select>
                </Form.Item>
                <Form.Item
                  name="projectOption"
                  label="Options"
                  required
                  rules={[
                    {
                      required: true,
                      message: "Please Select Project Option",
                    },
                  ]}
                >
                  <Select
                    style={{ width: 150 }}
                    placeholder="Select"
                    dropdownStyle={{ zIndex: "9999" }}
                  >
                    <Option value="2D">2D</Option>
                    <Option value="3D">3D</Option>
                  </Select>
                </Form.Item>
                <Form.Item
                  name="measurementType"
                  label="Measurement Type"
                  required
                  rules={[
                    {
                      required: true,
                      message: "Please Select Measurement Type",
                    },
                  ]}
                >
                  <Select
                    style={{ width: 150 }}
                    placeholder="Select"
                    dropdownStyle={{ zIndex: "9999" }}
                  >
                    <Option value="A">A</Option>
                    <Option value="B">B</Option>
                  </Select>
                </Form.Item>
                <Form.Item
                  name="measurementDate"
                  label="Measurement Date"
                  required
                  rules={[
                    {
                      required: true,
                      message: "Please Select Measurement Date",
                    },
                  ]}
                >
                  <DatePicker
                    disabledDate={disabledDate}
                    popupStyle={{ zIndex: "9999" }}
                  />
                </Form.Item>
                <Form.Item
                  name="reportMeasurementDate"
                  label="Report Measurement Date"
                  rules={[
                    {
                      required: true,
                      message: "Please Select Report Measurement Date",
                    },
                  ]}
                >
                  <DatePicker
                    disabledDate={disabledDate}
                    popupStyle={{ zIndex: "9999" }}
                  />
                </Form.Item>
                <Form.Item name="adjustmentDate" label="Adjustment Date">
                  <DatePicker
                    disabledDate={disabledDate}
                    popupStyle={{ zIndex: "9999" }}
                  />
                </Form.Item>
                {conditionForUpdatePriority(props.project, props.permissions) ? <Form.Item label="Priority">
                  <Checkbox
                    onChange={handleCheckboxChange}
                    checked={priority}
                  >
                  </Checkbox>
                </Form.Item> : ""}
                {conditionForUpdatePriority(props.project, props.permissions) ? <Form.Item label="Priority For Customer">
                  <Checkbox
                    onChange={handleCheckboxCustomerChange}
                    checked={priorityCustomer}
                  >
                  </Checkbox>
                </Form.Item> : ""}
                {conditionForUpdatePriority(props.project, props.permissions) ? 
                <Form.Item name="projectMessage" label="Message For Project">
                  <Input></Input>
                </Form.Item> : ""}
                {conditionForUpdatePriority(props.project, props.permissions) ? 
                <Form.Item name="customerMessage" label="Message For Customer">
                  <Input></Input>
                </Form.Item> : ""}

                {newProjectConfig.filter(c => c.companyId == props.project?.company?.id).map((item, index) => (
                  <Form.Item key={index} label={item.label + ':'}>
                    <Row gutter={[16, 10]} align="middle">
                      <Col xs={24}>
                        <Radio.Group
                          onChange={e => handleRadioChange(item.label, e.target.value)}
                          value={customerDataFormValues[item.label]}
                          style={{ display: 'flex', gap: '0px' }}
                        >
                          {item.values.map(v => (
                            <Radio key={v} value={v}>
                              {v}
                            </Radio>
                          ))}
                        </Radio.Group>
                      </Col>

                      <Col xs={20}>
                        <Input
                          placeholder="Notes..."
                          value={customerDataNotes[item.label]}
                          onChange={e => handleNoteChange(item.label, e.target.value)}
                        />
                      </Col>
                    </Row>
                  </Form.Item>
                ))}
              </Col>
            </Row>
            <div style={{ display: "flex", justifyContent: "center" }}>
              <PrimeBtn
                style={{
                  backgroundColor: "#037eea",
                  borderColor: "#037eea",
                  float: "right",
                  marginRight: "1rem",
                }}
                type="submit"
                label="Submit"
              />
            </div>
          </Form>
        </div>
      </Spin>

      <AddAgencyDialog
        visible={visibleAgencyDialog}
        setVisible={changeVisibleAgencyDialog}
        agency={selectedAgency ? selectedAgency : null}
      />
      <Dialog
        header="Information"
        style={{ width: "40vw" }}
        visible={informationDialog}
        onHide={() => setInformationDialog(false)}
      >
        <img style={{ width: "30vw" }} src={informationImage} />
      </Dialog>
    </React.Fragment>
  );
};

export default UpdateProjectForm;
